import React from 'react'
import Script from 'next/script'

type Props = {
  siteUrl: string
}

export const LinkedData = ({ siteUrl }: Props) => {
  const color = 'white'
  const logo = `${siteUrl}/linkeddata/dustin-symbol-${color}-1024x1024.png`

  const stringifiedData = JSON.stringify({
    '@context': 'http://schema.org/',
    '@type': 'Organization',
    url: siteUrl,
    logo: logo,
  })

  return (
    <Script
      id="organization-schema"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: stringifiedData }}></Script>
  )
}
